import { computed } from '@vue/composition-api';
import router from './../index';

export const useRoute = () => {
  const route = computed(() => router.currentRoute);

  return route;
};

export const useRouter = () => router;
